import { render, staticRenderFns } from "./BankId.vue?vue&type=template&id=72dc1942"
import script from "./BankId.vue?vue&type=script&lang=js"
export * from "./BankId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports